import { get } from 'lodash';
import { getFormValues as rfGetFormValues } from 'redux-form';

import { APPLIED_MENU_LIST_FORM_NAME } from 'Common/FormEnum';

const root = state => get(state, 'ManageMenuState.listAppliedMenus');

export const getAppliedMenus = state => get(root(state), 'appliedMenus');

export const getFetching = state => get(root(state), 'fetching');

export const getError = state => get(root(state), 'error');

export const getFormValues = state =>
  rfGetFormValues(APPLIED_MENU_LIST_FORM_NAME)(state) || {};

export const getDeleteSuccessful = state =>
  get(root(state), 'deleteSuccessful', false);

export const getDeleting = state => get(root(state), 'deleting', false);



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listappliedmenus/selectors.js